import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import PropTypes from "prop-types";

export default function AppFunnelChart(props) {
  const theme = useTheme();
  const data = props.data || {};
  const funnelData = data.stages || [];

  // Calculate conversion rate
  const totalRequests = funnelData.length > 0 ? funnelData[0].value : 0;
  const finalStage =
    funnelData.length > 0 ? funnelData[funnelData.length - 1].value : 0;
  const conversionRate =
    totalRequests > 0 ? Math.round((finalStage / totalRequests) * 100) : 0;

  const maxValue = Math.max(...funnelData.map((stage) => stage.value));

  return (
    <>
      <Stack sx={{ justifyContent: "space-between" }}>
        <Stack
          direction="row"
          sx={{
            alignContent: { xs: "center", sm: "flex-start" },
            alignItems: "center",
            gap: 1,
          }}
        >
          <Typography variant="h4" component="p">
            {conversionRate}%
          </Typography>
          <Chip
            size="small"
            color={data.changePercent > 0 ? "success" : "error"}
            label={`${data.changePercent > 0 ? "+" : ""}${data.changePercent}%`}
          />
        </Stack>
        <Typography variant="caption" sx={{ color: "text.secondary" }}>
          {props.title || "Funnel Chart"}
        </Typography>
      </Stack>

      <Box
        sx={{
          p: 2,
          height: 300,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {funnelData.map((stage, index) => {
          const widthPercentage = (stage.value / maxValue) * 100;
          const colors = [
            theme.palette.primary.main,
            theme.palette.primary.light,
            theme.palette.secondary.main,
            theme.palette.success.main,
            theme.palette.warning.main,
          ];

          return (
            <Box key={stage.label} sx={{ mb: 1 }}>
              <Box
                sx={{
                  minWidth: '35%',
                  width: `${widthPercentage}%`,
                  height: 40,
                  backgroundColor: colors[index % colors.length],
                  borderRadius: 1,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  px: 2,
                  margin: "0 auto",
                  position: "relative",
                  "&::after":
                    index < funnelData.length - 1
                      ? {
                          content: '""',
                          position: "absolute",
                          bottom: -8,
                          left: "50%",
                          transform: "translateX(-50%)",
                          width: 0,
                          height: 0,
                          borderLeft: "8px solid transparent",
                          borderRight: "8px solid transparent",
                          borderTop: `8px solid ${colors[index % colors.length]}`,
                        }
                      : {},
                }}
              >
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontSize: "0.8rem",
                  }}
                >
                  {stage.label}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "white",
                    fontWeight: 700,
                  }}
                >
                  {stage.value}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Box>
    </>
  );
}

AppFunnelChart.propTypes = {
  data: PropTypes.object,
  title: PropTypes.string,
};
